import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Adapter } from 'client/voladeum/adapters/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: Adapter[] = EMPTY_ARRAY;

export const adaptersSlice = createSlice({
  name: SLICE.ADAPTERS,
  initialState,
  reducers: {
    setAdapters: (_state, action: PayloadAction<Adapter[]>) => {
      return action.payload;
    },
    clearAdapters: () => {
      return initialState;
    },
  },
});

export const { setAdapters, clearAdapters } = adaptersSlice.actions;

export default adaptersSlice.reducer;
